import * as ReactDOM from 'react-dom/client';

import * as Sentry from '@sentry/react';

import { GlobalLoading } from '../components';
import { webEnvConfig } from '../config/web-env.config';

import { AppProvider } from './provider';
import { AppRouter } from './router';
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_WEB_DSN,
  environment: webEnvConfig.appEnv,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  tracesSampleRate: Number(import.meta.env.VITE_SENTRY_WEB_TRACES_SAMPLE_RATE ?? 0),
  enabled: !!import.meta.env.VITE_SENTRY_WEB_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  sendDefaultPii: true,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <AppProvider>
    <AppRouter />
    <GlobalLoading />
  </AppProvider>,
);
